import axiosInstance from '../axiosInterceptor/axiosInstance'

const youtubeAuthorizeScreen = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/youtube/account/authorize-url`
  return axiosInstance.get(url)
}

export default youtubeAuthorizeScreen
